<template>
  <VSelect v-model="modelValue" class="v-add-question" minimal @update:model-value="onUpdateModelValue">
    <template #value>
      <VButton class="v-add-question__btn" :icon :label="buttonLabel" :plain :type="buttonType" />
    </template>

    <VOption v-for="(label, type) in selectableQuestionTypeOptions" :key="type" :label :value="type" />
  </VSelect>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { type SomeOtherString, type VButtonType, type VIconIcon } from '../../types.ts'
import VOption from '../Select/VOption.vue'
import VSelect from '../Select/VSelect.vue'
import VButton from '../VButton.vue'
import { type Blueprint, type QuestionType } from './useBlueprint.ts'
import { useSelectableQuestionTypes } from './useSelectableQuestionTypes.ts'

interface Props {
  blueprint: Blueprint
  buttonLabel: string
  buttonType?: VButtonType
  plain?: boolean
  icon?: VIconIcon
  includeTypes?: (QuestionType | SomeOtherString)[]
}

const props = withDefaults(defineProps<Props>(), {
  buttonType: undefined,
  icon: 'ChevronDown',
  includeTypes: undefined,
})

const emit = defineEmits<{
  select: [QuestionType]
}>()

const { selectableQuestionTypeOptions } = useSelectableQuestionTypes(props)

const modelValue = ref<QuestionType | ''>('')

function onUpdateModelValue() {
  if (modelValue.value) {
    emit('select', modelValue.value)
  }
  modelValue.value = ''
}
</script>

<style>
.v-add-question {
  display: inline-block;

  > .v-popper-reference {
    display: inline-block;

    > .v-input {
      display: inline-block;
      width: auto;

      > div {
        display: inline-flex;
      }

      .v-input__inner {
        padding: 0 !important;
      }
    }
  }

  &.v-popper--active .v-btn__icon.v-icon-chevrondown {
    transform: rotate(180deg);
  }

  .v-input__suffix {
    display: none;
  }
}

.v-add-question__btn {
  pointer-events: auto;
}
</style>
